import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import DownloadIcon from '@mui/icons-material/Download'
import Markdown from '../Markdown'
import { bodyText, colours } from '../player/playerStyles'

const fileNameFor = (title) =>
  `${String(title ?? 'course').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase() || 'course'}-handout.pdf`

const DownloadBlock = ({ block, content }) => {
  const [status, setStatus] = useState('idle')
  const title = content?.course?.title
  const handout = content?.handout

  const download = async () => {
    setStatus('working')
    try {
      // The PDF renderer is large, so it is only fetched when asked for.
      const [{ downloadPdf }, { default: HandoutPDF }] = await Promise.all([
        import('../../../helpers/downloadPdf'),
        import('../pdf/HandoutPDF'),
      ])
      await downloadPdf(<HandoutPDF title={title} markdown={handout} />, fileNameFor(title))
      setStatus('done')
    } catch (error) {
      console.error(error)
      setStatus('failed')
    }
  }

  return (
    <Box>
      <Markdown sx={bodyText}>{block.body}</Markdown>
      {handout ? (
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={status === 'working' ? undefined : download}
          aria-disabled={status === 'working'}
          sx={{ mt: 2.5 }}
        >
          Download the quick-reference handout (PDF)
        </Button>
      ) : (
        <Typography sx={{ ...bodyText, mt: 2, color: colours.muted }}>There is no handout for this course.</Typography>
      )}
      <Typography aria-live="polite" sx={{ ...bodyText, fontSize: '1rem', mt: 1, minHeight: '1.6em', color: status === 'failed' ? colours.bad : colours.muted }}>
        {status === 'working' && 'Preparing your handout.'}
        {status === 'done' && 'Your handout has downloaded.'}
        {status === 'failed' && 'We could not create the handout. Please try again.'}
      </Typography>
    </Box>
  )
}

export default DownloadBlock
